const API_URL = process.env.REACT_APP_API_URL || '';

// Check if a JWT token is expired (with 30s buffer)
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now() + 30000;
  } catch {
    return true;
  }
}

// Get a valid access token, refreshing if needed
export async function getValidToken() {
  let token = localStorage.getItem('token');

  if (!isTokenExpired(token)) {
    return token;
  }

  // Token expired — try to refresh
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken || isTokenExpired(refreshToken)) {
    // Refresh token also expired — user needs to log in again
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/';
    return null;
  }

  try {
    const res = await fetch(`${API_URL}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!res.ok) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/';
      return null;
    }

    const data = await res.json();
    localStorage.setItem('token', data.token);
    return data.token;
  } catch {
    return null;
  }
}
